export default __webpack_public_path__ + "static/media/imgDark2.caf1dee1.png";